export default "/images/e00f4fe7593ad3a4890484db15a4b0cc.avif";